import { StayEngagedIcon, ShareCircleIcon, GetStartedIcon } from "./svg";
import { isReloy } from "../../../utils/isClient";
import LoyaltyEngagementSlider from "../../Common/LoyaltyEngagementSlider";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HowToEarnCoins = function HowToEarnCoins(_ref) {
  var config = _ref.config;
  var isReloyClient = isReloy(config);
  var iconColor = config === null || config === void 0 ? void 0 : config.primaryColor;
  var earnCoinsData = isReloyClient ? [{
    title: "Welcome Points",
    description: "Join The High Table community to receive HT Points instantly.",
    icon: /*#__PURE__*/_jsx(GetStartedIcon, {
      color: iconColor
    })
  }, {
    title: "Lead Submission",
    description: "Earn HT Points for every lead you register through the platform.",
    icon: /*#__PURE__*/_jsx(StayEngagedIcon, {
      color: iconColor
    })
  }, {
    title: "Referral Success",
    description: "Receive maximum HT Points once your referral completes the process and partners with Reloy.",
    icon: /*#__PURE__*/_jsx(ShareCircleIcon, {
      color: iconColor
    })
  }] : [{
    title: "Get Started",
    description: "From downloading the app to completing your profile, earn loyalty coins as you begin.",
    icon: /*#__PURE__*/_jsx(GetStartedIcon, {
      color: iconColor
    })
  }, {
    title: "Stay Engaged",
    description: "From exploring feeds to participating in contests, engage across activities and earn coins along the way.",
    icon: /*#__PURE__*/_jsx(StayEngagedIcon, {
      color: iconColor
    })
  }, {
    title: "Share with Your Circle",
    description: "From submitting a referral to getting them to visit the site and complete a booking, earn loyalty coins at every step.",
    icon: /*#__PURE__*/_jsx(ShareCircleIcon, {
      color: iconColor
    })
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "pt-12",
    children: [/*#__PURE__*/_jsx("p", {
      className: "".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " text-2xl lg:text-3xl text-center font-medium"),
      children: isReloyClient ? "How to Earn HT Points" : "How to Earn Coins"
    }), isReloyClient ? /*#__PURE__*/_jsx(LoyaltyEngagementSlider, {
      config: config,
      slides: earnCoinsData
    }) : /*#__PURE__*/_jsx("div", {
      className: "mt-8 flex gap-4 overflow-x-auto scrollbar-hide w-full lg:grid lg:grid-cols-3 lg:overflow-hidden",
      children: earnCoinsData.map(function (item, index) {
        return /*#__PURE__*/_jsxs("div", {
          className: "min-w-full shrink-0 lg:min-w-0 flex gap-5 rounded-lg p-4 lg:p-8 } ".concat(config !== null && config !== void 0 && config.darkMode ? "border-[2px] border-primary" : "", " ").concat(config !== null && config !== void 0 && config.darkTheme ? "bg-black" : "bg-[#ededed]"),
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex h-20 w-20 min-w-[80px] items-center justify-center rounded-full ".concat(config !== null && config !== void 0 && config.darkTheme ? "bg-[#2A180B]" : "bg-[#dddddd]"),
            children: item.icon
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("p", {
              className: "mb-3 text-xl font-medium  ".concat(config !== null && config !== void 0 && config.darkTheme ? "" : "text-black"),
              style: config !== null && config !== void 0 && config.darkTheme ? {
                color: config === null || config === void 0 ? void 0 : config.primaryColor
              } : {},
              children: item.title
            }), /*#__PURE__*/_jsx("p", {
              className: "text-base ".concat(config !== null && config !== void 0 && config.darkTheme ? "text-white" : "text-black"),
              children: item.description
            })]
          })]
        }, index);
      })
    })]
  });
};
export default HowToEarnCoins;